<script setup>
import {ref, onMounted} from 'vue'
import ButtonSave from "@/components/common/button/ButtonSave.vue";
import {handleError} from "@/utils/errors.js";
import {useI18n} from "vue-i18n";
import router from "@/router/index.js";
import {useRoute} from "vue-router";
import BasePage from "@/components/Layouts/BasePage.vue";
import {QrcodeLogoEntity} from "@/entities/QrcodeLogoEntity.js";
import {createLogo, getLogo, updateLogo} from "@/services/api/qrcode.js";

const { t } = useI18n();
const route = useRoute();
const loading = ref(false);
const id = route.params.id;
const isMounted = ref(false);
const entity = ref(new QrcodeLogoEntity());
const formData = ref({ name: '', image: null });
const fileInput = ref(null);

function onFile(e){ const f = e.target.files?.[0]; formData.value.image = f || null; }

async function onSave() {
  try {
    if (!formData.value.name) { message.error(t('common.messages.errors.requiredField')); return; }
    if (!id && !formData.value.image) { message.error('Imagem é obrigatória.'); return; }
    loading.value = true;
    const fd = new FormData(); fd.append('name', formData.value.name); if (formData.value.image) fd.append('image', formData.value.image);
    if (id) { await updateLogo(id, fd); } else { await createLogo(fd); }
    await router.push(entity.value.pages.list.route?.at(-1)); message.success(t("common.messages.success.save"));
  } catch (error) { console.error(error); message.error(await handleError(error, t)); }
  finally { loading.value = false; }
}

onMounted(async () => {
  try { isMounted.value=false; if (id) { const response = await getLogo(id); formData.value.name = response.data?.name ?? ''; } }
  catch (e) { console.error(e); } finally { isMounted.value = true; }
});
</script>

<template>
  <BasePage :loading-mounted="isMounted" :entity="entity">
    <template #default>
      <v-form>
        <v-row>
          <v-col cols="12" md="6">
            <div class="trezo-form-group">
              <v-label class="d-block fw-medium text-black is-required">{{ t('common.labels.name') }}</v-label>
            </div>
            <v-text-field v-model="formData.name" :placeholder="t('common.labels.name')" density="compact" hide-details variant="outlined" />
          </v-col>
          <v-col cols="12" md="6">
            <div class="trezo-form-group">
              <v-label class="d-block fw-medium text-black" :class="{ 'is-required': !id }">Logo</v-label>
            </div>
            <input ref="fileInput" type="file" accept="image/*" @change="onFile" />
            <div class="text-caption text-medium-emphasis mt-1">Máx. 50KB</div>
          </v-col>
        </v-row>
      </v-form>
      <ButtonSave :loading="loading" @click="onSave" />
    </template>
  </BasePage>
</template>

